import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import API_BASE_URL from '../config/api';

const MACHINE_TYPES = [
  { code: "HAPPYSEEDER", name: "HAPPY SEEDER" },
  { code: "SUPERSEEDER", name: "SUPER SEEDER" },
  { code: "PADDYSTRAWCHOPPER", name: "PADDY STRAW CHOPPER" },
  { code: "MULCHER", name: "MULCHER" },
  { code: "RMBPLOUGH", name: "RMB PLOUGH" },
  { code: "ZEROTILLDRILL", name: "ZERO TILL DRILL" },
  { code: "SUPERSMS", name: "SUPER SMS" },
  { code: "ROTARYSLASHER", name: "ROTARY SLASHER" },
  { code: "SHRUBMASTER", name: "SHRUB MASTER" },
  { code: "CUTTERCUMSPREADER", name: "CUTTER CUM SPREADER" },
  { code: "ROTAVATOR", name: "ROTAVATOR" },
  { code: "TRACTOR", name: "TRACTOR" },
  { code: "TRACTORTROLLEY", name: "TRACTOR TROLLEY" },
  { code: "LASERLEVELLER", name: "LASER LEVELLER" },
  { code: "DIRECTSEEDERRICE", name: "DIRECT SEEDER RICE  (DSR)" },
  { code: "MAIZEPLANTERMECHANICAL", name: "MAIZE PLANTER MECHNICAL" },
  { code: "MAIZEPLANTERVACCUM", name: "MAIZE PLANTER VACCUM" },
  { code: "SPRAYPUMP", name: "SPRAY PUMP" },
  { code: "PRESSUREDISKS", name: "PRESSURE DISKS" },
  { code: "DISKLOCK", name: "DISK LOCK" },
  { code: "BIOFERTILIZERSPREADER", name: "(BIO) FERTILIZER SPREADER" },
  { code: "CULTIVATOR", name: "CULTIVATOR" },
  { code: "SUBSOILER", name: "SUB SOILER" },
  { code: "POWERCLEANER", name: "POWER CLEANER" },
  { code: "DISCRAZOR", name: "DISC RAZOR" },
  { code: "HARROWTRIPPLE", name: "HARROW TRIPPLE" },
  { code: "COTTONSEEDDRILL", name: "COTTON SEED DRILL" },
  { code: "WATERTANK", name: "WATER TANK" },
  { code: "SUHAGA", name: "SUHAGA" },
  { code: "WHEATSEEDFAN", name: "WHEAT SEED FAN " },
  { code: "SEEDGRINDINGMACHINE", name: "SEED GRINDING MACHINE" },
  { code: "JINDRA", name: "JINDRA" },
  { code: "COMBINE", name: "COMBINE" },
  { code: "SEELARCOTTON", name: "SEELAR COTTON " },
  { code: "GENERATOR", name: "GENERATOR" },
  { code: "WHEATSEEDDRILL", name: "WHEAT SEED DRILL" },
  { code: "REAPER", name: "REAPER" },
  { code: "PLOUGH", name: "PLOUGH" },
  { code: "GROUNDLEVELLER", name: "GROUND LEVELLER" },
  { code: "STRAWREAPER", name: "STRAW REAPER" },
  { code: "POTATOPLANTER", name: "POTATO PLANTER" },
  { code: "TAWIAN", name: "TAWIAN" },
  { code: "SIMPLELEVELLER", name: "SIMPLE LEVELLER" },
  { code: "LOADER", name: "LOADER" },
  { code: "POTATODRILL", name: "POTATO DRILL" },
  { code: "MULTIDRILLMACHINE", name: "MULTI DRILL MACHINE" },
  { code: "PUDDLER", name: "PUDDLER (KADDO)" },
  { code: "CHOPPER", name: "CHOPPER" },
  { code: "CORNDRILL", name: "CORN DRILL" },
  { code: "PEASMACHINE", name: "PEAS MACHINE" },
  { code: "SEEDDRILL", name: "SEED DRILL" },
  { code: "CHIZLER", name: "CHIZLER" },
  { code: "PADDYPLANTER", name: "PADDY PLANTER" },
  { code: "DIESELTANK", name: "DIESEL TANK" },
  { code: "BHAUNI", name: "BHAUNI" },
  { code: "TOTA", name: "TOTA" },
  { code: "TILLER", name: "TILLER" },
  { code: "KARAH", name: "KARAH" },
  { code: "TARFALI", name: "TARFALI" },
  { code: "RAZOR", name: "RAZOR" },
  { code: "BALER", name: "BALER" },
  { code: "THRESHER", name: "THRESHER" },
  { code: "KARCHAMACHINE", name: "KARCHA MACHINE" },
  { code: "RATOR", name: "RATOR" },
  { code: "SUGARCANERAGER", name: "SUGARCANE RAGER" },
  { code: "DISCHARROW", name: "DISC HARROW" },
  { code: "CHAINKUPPI", name: "CHAIN KUPPI" },
  { code: "SUGARCANESEEDER", name: "SUGARCANE SEEDER" },
  { code: "GRINDER", name: "GRINDER" },
  { code: "CHANGER", name: "CHANGER" },
  { code: "TRIPPLEPLOUGH", name: "TRIPPLE PLOUGH" },
  { code: "RAKER", name: "RAKER" },
  { code: "CORNHARVESTER", name: "CORN HARVESTER" },
  { code: "CUTTER", name: "CUTTER" },
  { code: "MOTORMACHINE", name: "MOTOR MACHINE / MOTOR EXTRACTION MACHINE" },
  { code: "DISCPLOUGH", name: "DISC PLOUGH" },
  { code: "GAINIPLOUGH", name: "GAINI PLOUGH" },
  { code: "DUGPLOUGH", name: "DUG PLOUGH" },
  { code: "OFFSETHARROW", name: "OFFSET HARROW" },
  { code: "JAAL", name: "JAAL" },
  { code: "TARAKADI", name: "TARAKADI" },
  { code: "CARROTMACHINE", name: "CARROT MACHINE" },
  { code: "DISCBEDMAKER", name: "DISC BED MAKER" },
  { code: "LOADERBUCKET", name: "LOADER BUCKET" },
  { code: "SEEDGRADER", name: "SEED GRADER" },
  { code: "ACHATHALL", name: "ACHAT HALL" },
  { code: "TAWAWATTA", name: "TAWA WATTA" },
  { code: "JACK", name: "JACK" },
  { code: "SURFACESEEDER", name: "SURFACE SEEDER" },
  { code: "SMARTSEEDER", name: "SMART SEEDER" }
];

const AddTransactionPage = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const editRecord = location.state?.transaction || null;

  const [saving, setSaving] = useState(false);
  const [searching, setSearching] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  // Form Fields
  const [transactionDate, setTransactionDate] = useState(() => editRecord?.TransactionDate || new Date().toISOString().split('T')[0]);
  const [farmerMobileNo, setFarmerMobileNo] = useState(editRecord?.FarmerMobileNo || '');
  const [farmerName, setFarmerName] = useState(editRecord?.FarmerName || '');
  const [fatherName, setFatherName] = useState(editRecord?.FatherName || '');
  const [farmerProfile, setFarmerProfile] = useState(editRecord?.FarmerProfile || '');
  const [village, setVillage] = useState(editRecord?.Village || '');

  // Searchable Machine Inputs
  const [machineSearchText, setMachineSearchText] = useState('');
  const [selectedMachineCode, setSelectedMachineCode] = useState('');
  const [machineHrs, setMachineHrs] = useState('');
  const [chargesPerHrs, setChargesPerHrs] = useState('');
  const [tractorRequired, setTractorRequired] = useState(false);
  const [tractorRental, setTractorRental] = useState('');
  const [rowErrors, setRowErrors] = useState({});

  // Added Machines List
  const [machines, setMachines] = useState(editRecord?.Machines || []);

  // Calculate rental for dynamic machine input row
  const currentMachineHrs = Number(machineHrs) || 0;
  const currentChargesPerHrs = Number(chargesPerHrs) || 0;
  const currentTractorRental = tractorRequired ? (Number(tractorRental) || 0) : 0;
  const currentRentalCharges = currentMachineHrs * currentChargesPerHrs;
  const currentTotalRental = currentRentalCharges + currentTractorRental;

  // Society Machine Counts State
  const [societyMachineCounts, setSocietyMachineCounts] = useState({});

  useEffect(() => {
    const fetchSocietyCounts = async () => {
      const societyId = user?.society?._id;
      if (!societyId) return;
      try {
        const res = await fetch(`${API_BASE_URL}/api/machines/counts?societyId=${societyId}`);
        const data = await res.json();
        if (data.success && data.counts) {
          setSocietyMachineCounts(data.counts);
        }
      } catch (err) {
        console.error('Error fetching society machine counts:', err);
      }
    };
    fetchSocietyCounts();
  }, [user]);

  // Search farmer by mobile number
  const handleFarmerSearch = async () => {
    const cleanedMobile = farmerMobileNo.replace(/\D/g, '');
    if (cleanedMobile.length !== 10) {
      setStatus({ type: 'error', message: 'Farmer Mobile Number must be exactly 10 digits.' });
      return;
    }
    setSearching(true);
    setStatus({ type: '', message: '' });

    try {
      const res = await fetch(`${API_BASE_URL}/api/transactions/farmer?mobile=${cleanedMobile}`);
      const data = await res.json();

      if (data.success && data.farmer) {
        setFarmerName(data.farmer.FarmerName || '');
        setFatherName(data.farmer.FatherName || '');
        setFarmerProfile(data.farmer.FarmerProfile || '');
        setVillage(data.farmer.Village || '');
      } else {
        setStatus({ type: 'error', message: 'Farmer not found with this mobile number.' });
      }
    } catch (err) {
      console.error('Error searching farmer:', err);
    } finally {
      setSearching(false);
    }
  };

  // Handle Searchable Machine Selection / Typing
  const handleMachineSearchChange = (e) => {
    const val = e.target.value;
    setMachineSearchText(val);

    const matched = MACHINE_TYPES.find(
      m => m.name.toLowerCase() === val.trim().toLowerCase() || m.code.toLowerCase() === val.trim().toLowerCase()
    );

    if (matched) {
      setSelectedMachineCode(matched.code);
    } else {
      setSelectedMachineCode('');
    }
  };

  const handleMachineSelect = (e) => {
    const code = e.target.value;
    setSelectedMachineCode(code);
    const matched = MACHINE_TYPES.find(m => m.code === code);
    if (matched) {
      setMachineSearchText(matched.name);
    }
  };

  // Add machine to list table
  const handleAddMachine = () => {
    const errors = {};

    let finalCode = selectedMachineCode;
    let finalName = machineSearchText;

    if (!finalCode && machineSearchText) {
      const matched = MACHINE_TYPES.find(
        m => m.name.toLowerCase() === machineSearchText.trim().toLowerCase()
      );
      if (matched) {
        finalCode = matched.code;
        finalName = matched.name;
      }
    }

    if (!finalCode) errors.machine = 'Please select or type a valid Machine';
    if (!machineHrs || Number(machineHrs) <= 0) errors.hrs = 'Please provide Rented Hrs';
    if (tractorRequired && (!tractorRental || Number(tractorRental) < 0)) errors.tractor = 'Please provide Tractor Rental Charges';

    if (Object.keys(errors).length > 0) {
      setRowErrors(errors);
      return;
    }

    // Check machine count for society
    const count = Number(societyMachineCounts[finalCode]) || 0;
    if (count <= 0) {
      alert(`Machine cannot be added as ${finalName || 'this machine'} does not exist in society machine inventory.`);
      setStatus({ type: 'error', message: `Machine cannot be added as ${finalName || 'this machine'} count is 0 for this society.` });
      return;
    }

    setRowErrors({});
    setStatus({ type: '', message: '' });

    const newMachine = {
      MachineCode: finalCode,
      Machine: finalName,
      MachineHrs: currentMachineHrs,
      ChargesPerHrs: currentChargesPerHrs,
      MachineRental: currentRentalCharges,
      TractorRequired: tractorRequired,
      TractorRental: currentTractorRental,
      TotalRental: currentTotalRental
    };

    setMachines(prev => [...prev, newMachine]);

    // Reset machine row input
    setMachineSearchText('');
    setSelectedMachineCode('');
    setMachineHrs('');
    setChargesPerHrs('');
    setTractorRequired(false);
    setTractorRental('');
  };

  const handleRemoveMachine = (index) => {
    setMachines(prev => prev.filter((_, i) => i !== index));
  };

  // Inline edit handler for added machines
  const handleUpdateAddedMachine = (index, field, value) => {
    const targetMachine = machines[index];
    if (targetMachine) {
      const count = Number(societyMachineCounts[targetMachine.MachineCode]) || 0;
      if (count <= 0) {
        alert(`Machine cannot be updated as ${targetMachine.Machine || 'this machine'} count is 0 in society inventory.`);
        return;
      }
    }

    setMachines(prev => prev.map((m, i) => {
      if (i !== index) return m;

      const updated = { ...m };

      if (field === 'MachineHrs') {
        updated.MachineHrs = Number(value) || 0;
      } else if (field === 'ChargesPerHrs') {
        updated.ChargesPerHrs = Number(value) || 0;
      } else if (field === 'TractorRequired') {
        updated.TractorRequired = value;
        if (!value) updated.TractorRental = 0;
      } else if (field === 'TractorRental') {
        updated.TractorRental = updated.TractorRequired ? (Number(value) || 0) : 0;
      }

      // Recalculate rentals
      updated.MachineRental = updated.MachineHrs * updated.ChargesPerHrs;
      updated.TotalRental = updated.MachineRental + (updated.TractorRequired ? updated.TractorRental : 0);

      return updated;
    }));
  };

  // Grand Totals
  const totalMachineHrs = machines.reduce((sum, m) => sum + m.MachineHrs, 0);
  const totalMachineRental = machines.reduce((sum, m) => sum + m.MachineRental, 0);
  const totalTractorRental = machines.reduce((sum, m) => sum + m.TractorRental, 0);
  const totalChargesPerHrs = machines.reduce((sum, m) => sum + m.ChargesPerHrs, 0);
  const totalTotalRental = machines.reduce((sum, m) => sum + m.TotalRental, 0);

  // Form Field Validation Errors
  const [formErrors, setFormErrors] = useState({});

  // Save Transaction
  const handleSave = async () => {
    const errors = {};

    const todayStr = new Date().toISOString().split('T')[0];

    if (!transactionDate) {
      errors.transactionDate = 'Please select Transaction Date';
    } else if (transactionDate > todayStr) {
      errors.transactionDate = 'Transaction Date cannot be in the future';
    }

    const cleanedMobile = farmerMobileNo.replace(/\D/g, '');
    if (!farmerMobileNo) {
      errors.farmerMobileNo = 'Please enter Farmer Mobile Number';
    } else if (cleanedMobile.length !== 10) {
      errors.farmerMobileNo = 'Farmer Mobile Number must be exactly 10 digits';
    }

    if (!farmerName.trim()) {
      errors.farmerName = 'Please enter Farmer Name';
    }

    if (!fatherName.trim()) {
      errors.fatherName = 'Please enter Father Name';
    }

    if (!farmerProfile) {
      errors.farmerProfile = 'Please select Farmer Profile';
    }

    if (!village.trim()) {
      errors.village = 'Please enter Farmer Village';
    }

    if (machines.length === 0) {
      errors.machines = 'Please add at least one machine to the transaction';
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setStatus({ type: 'error', message: 'Please fix all highlighted errors before saving.' });
      return;
    }

    setFormErrors({});
    setSaving(true);
    setStatus({ type: '', message: '' });

    const payload = {
      SocietyID: user.society ? user.society._id : '',
      Society: user.society ? user.society.SOCIETY : '',
      Division: user.society ? user.society.DIVISION : '',
      District: user.society ? user.society.DISTRICT : '',
      AR: user.society ? user.society.AR : '',
      Village: village,
      FarmerName: farmerName,
      FatherName: fatherName,
      FarmerMobileNo: farmerMobileNo,
      FarmerProfile: farmerProfile,
      TransactionDate: transactionDate,
      TotalMachineHrs: totalMachineHrs,
      TotalMachineRental: totalMachineRental,
      TotalTractorRental: totalTractorRental,
      TotalChargesPerHrs: totalChargesPerHrs,
      TotalTotalRental: totalTotalRental,
      Action: editRecord ? 'EDIT' : 'NEW',
      ActionBy: user.name,
      ActionByEmailID: user.email,
      Machines: machines
    };

    try {
      const url = editRecord ? `${API_BASE_URL}/api/transactions/${editRecord._id}` : `${API_BASE_URL}/api/transactions`;
      const method = editRecord ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (res.ok && data.success) {
        if (editRecord) {
          navigate('/transactions', { state: { toastMessage: 'Transaction updated successfully!', reload: true } });
        } else {
          // Reset screen fields for new entry
          setFarmerMobileNo('');
          setFarmerName('');
          setFatherName('');
          setFarmerProfile('');
          setVillage('');
          setMachineSearchText('');
          setSelectedMachineCode('');
          setMachineHrs('');
          setChargesPerHrs('');
          setTractorRequired(false);
          setTractorRental('');
          setMachines([]);
          setRowErrors({});
          setTransactionDate(new Date().toISOString().split('T')[0]);
          setStatus({ type: 'success', message: 'Transaction saved successfully! Screen reset for new entry.' });
        }
      } else {
        setStatus({ type: 'error', message: data.message || 'Failed to save transaction.' });
      }
    } catch (err) {
      console.error('Error saving transaction:', err);
      setStatus({ type: 'error', message: 'Network error saving transaction.' });
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    navigate(editRecord ? '/transactions' : '/home');
  };

  return (
    <FormContainer
      title={editRecord ? "Edit Transaction" : "Add New Transaction"}
      onClose={handleClose}
      onSave={handleSave}
      onCancel={handleClose}
      saveText={editRecord ? "Update" : "Save"}
      saving={saving}
    >
      <div>
        {status.message && (
          <div className={`alert-message ${status.type}`}>
            {status.message}
          </div>
        )}

        {/* Transaction Date */}
        <div className="form-group" style={{ maxWidth: '350px' }}>
          <label>Transaction Date <span style={{ color: '#dc2626' }}>*</span></label>
          <input
            type="date"
            max={new Date().toISOString().split('T')[0]}
            value={transactionDate}
            onChange={(e) => {
              setTransactionDate(e.target.value);
              if (formErrors.transactionDate) setFormErrors(prev => ({ ...prev, transactionDate: null }));
            }}
            disabled={saving}
            style={{ border: formErrors.transactionDate ? '1px solid #dc2626' : undefined }}
          />
          {formErrors.transactionDate && (
            <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: '500' }}>
              {formErrors.transactionDate}
            </span>
          )}
        </div>

        {/* 3-Column Desktop Grid for Farmer Mobile, Farmer Name & Father Name */}
        <div className="farmer-details-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '20px' }}>
          {/* Farmer Mobile & Search */}
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>ਕਿਸਾਨ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ (Farmer Mobile No.) <span style={{ color: '#dc2626' }}>*</span></label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input
                type="tel"
                maxLength={10}
                value={farmerMobileNo}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, '');
                  if (val.length <= 10) setFarmerMobileNo(val);
                  if (formErrors.farmerMobileNo) setFormErrors(prev => ({ ...prev, farmerMobileNo: null }));
                }}
                placeholder="Enter 10-digit mobile number"
                disabled={saving}
                style={{ border: formErrors.farmerMobileNo ? '1px solid #dc2626' : undefined }}
              />
              <button
                type="button"
                onClick={handleFarmerSearch}
                disabled={farmerMobileNo.length !== 10 || searching || saving}
                style={{
                  background: farmerMobileNo.length === 10 && !searching && !saving ? '#f59e0b' : '#cbd5e1',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '0 16px',
                  fontWeight: '600',
                  cursor: farmerMobileNo.length === 10 && !searching && !saving ? 'pointer' : 'not-allowed',
                  whiteSpace: 'nowrap',
                  transition: 'all 0.2s'
                }}
              >
                {searching ? '...' : '🔍 Search'}
              </button>
            </div>
            {formErrors.farmerMobileNo && (
              <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: '500' }}>
                {formErrors.farmerMobileNo}
              </span>
            )}
          </div>

          {/* Farmer Name */}
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>ਕਿਸਾਨ ਦਾ ਨਾਮ (Farmer Name) <span style={{ color: '#dc2626' }}>*</span></label>
            <input
              type="text"
              value={farmerName}
              onChange={(e) => {
                setFarmerName(e.target.value);
                if (formErrors.farmerName) setFormErrors(prev => ({ ...prev, farmerName: null }));
              }}
              placeholder="Enter farmer name"
              disabled={saving}
              style={{ border: formErrors.farmerName ? '1px solid #dc2626' : undefined }}
            />
            {formErrors.farmerName && (
              <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: '500' }}>
                {formErrors.farmerName}
              </span>
            )}
          </div>

          {/* Father Name */}
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>ਪਿਤਾ ਦਾ ਨਾਮ (Father Name) <span style={{ color: '#dc2626' }}>*</span></label>
            <input
              type="text"
              value={fatherName}
              onChange={(e) => {
                setFatherName(e.target.value);
                if (formErrors.fatherName) setFormErrors(prev => ({ ...prev, fatherName: null }));
              }}
              placeholder="Enter father name"
              disabled={saving}
              style={{ border: formErrors.fatherName ? '1px solid #dc2626' : undefined }}
            />
            {formErrors.fatherName && (
              <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: '500' }}>
                {formErrors.fatherName}
              </span>
            )}
          </div>
        </div>

        {/* Same Row Grid for Farmer Profile & Farmer Village */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '32px' }}>
          {/* Farmer Profile */}
          <div className="form-group" style={{ width: '350px', marginBottom: 0 }}>
            <label>ਕਿਸਾਨ ਪ੍ਰੋਫਾਈਲ (Farmer Profile) <span style={{ color: '#dc2626' }}>*</span></label>
            <select
              value={farmerProfile}
              onChange={(e) => {
                setFarmerProfile(e.target.value);
                if (formErrors.farmerProfile) setFormErrors(prev => ({ ...prev, farmerProfile: null }));
              }}
              disabled={saving}
              style={{
                width: '100%',
                padding: '12px 16px',
                borderRadius: '8px',
                border: formErrors.farmerProfile ? '1px solid #dc2626' : '1px solid #e0e5f2',
                fontSize: '14px',
                outline: 'none'
              }}
            >
              <option value="">Select Profile</option>
              <option value="Marginal">Marginal (Small Land)</option>
              <option value="Small">Small</option>
              <option value="Medium">Medium</option>
              <option value="Large">Large</option>
            </select>
            {formErrors.farmerProfile && (
              <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: '500' }}>
                {formErrors.farmerProfile}
              </span>
            )}
          </div>

          {/* Farmer Village */}
          <div className="form-group" style={{ width: '350px', marginBottom: 0 }}>
            <label>ਕਿਸਾਨ ਦਾ ਪਿੰਡ (Farmer Village) <span style={{ color: '#dc2626' }}>*</span></label>
            <input
              type="text"
              value={village}
              onChange={(e) => {
                setVillage(e.target.value);
                if (formErrors.village) setFormErrors(prev => ({ ...prev, village: null }));
              }}
              placeholder="Enter village"
              disabled={saving}
              style={{ border: formErrors.village ? '1px solid #dc2626' : undefined }}
            />
            {formErrors.village && (
              <span style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: '500' }}>
                {formErrors.village}
              </span>
            )}
          </div>
        </div>

        {/* Machinery Selection Table */}
        <div style={{ overflowX: 'auto', border: formErrors.machines ? '1px solid #dc2626' : '1px solid #e0e5f2', borderRadius: '8px', marginBottom: '24px' }}>
          {formErrors.machines && (
            <div style={{ background: '#fef2f2', color: '#dc2626', padding: '10px 14px', fontSize: '13px', fontWeight: '600', borderBottom: '1px solid #fee2e2' }}>
              ⚠️ {formErrors.machines}
            </div>
          )}
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'left' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e0e5f2', color: '#1e293b' }}>
                <th style={{ padding: '12px', minWidth: '220px' }}>ਮਸ਼ੀਨਾਂ (Machine(s))</th>
                <th style={{ padding: '12px', width: '110px' }}>ਘੰਟੇ) ਕਿਰਾਇਆ (Hour(s) Rented)</th>
                <th style={{ padding: '12px', width: '120px' }}>ਘੰਟੇ ਪ੍ਰਤੀ ਕਿਰਾਇਆ ਕਿਰਾਏ (Rental Charges Per Hour)</th>
                <th style={{ padding: '12px', width: '110px' }}>ਕਿਰਾਏ ਦਾ ਖਰਚਾ (Rental Charges)</th>
                <th style={{ padding: '12px', width: '110px' }}>ਟਰੈਕਟਰ ਲੋੜੀਂਦਾ (Tractor Required)</th>
                <th style={{ padding: '12px', width: '130px' }}>ਟਰੈਕਟਰ ਕਿਰਾਇਆ (Tractor Rental)</th>
                <th style={{ padding: '12px', width: '100px' }}>ਕੁਲ ਕਿਰਾਇਆ (Total Rental)</th>
                <th style={{ padding: '12px', width: '80px' }}></th>
              </tr>
            </thead>
            <tbody>
              {/* Add Machine Input Row with Searchable Typeable Combobox */}
              <tr style={{ borderBottom: '1px solid #e0e5f2', background: '#fcfcfd' }}>
                <td style={{ padding: '10px' }}>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      list="machine-options"
                      value={machineSearchText}
                      onChange={handleMachineSearchChange}
                      placeholder="Type or Select Machine..."
                      style={{
                        width: '100%',
                        padding: '8px 10px',
                        borderRadius: '6px',
                        border: rowErrors.machine ? '1px solid #dc2626' : '1px solid #cbd5e1',
                        fontSize: '13px',
                        outline: 'none'
                      }}
                    />
                    <datalist id="machine-options">
                      {MACHINE_TYPES.map(m => (
                        <option key={m.code} value={m.name} />
                      ))}
                    </datalist>
                  </div>
                  {rowErrors.machine && <div style={{ color: '#dc2626', fontSize: '11px', marginTop: '4px' }}>{rowErrors.machine}</div>}
                </td>
                <td style={{ padding: '10px' }}>
                  <input
                    type="number"
                    min="1"
                    max="99"
                    value={machineHrs}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === '' || (Number(val) >= 0 && val.length <= 2)) {
                        setMachineHrs(val);
                      }
                    }}
                    placeholder="00"
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '6px',
                      border: rowErrors.hrs ? '1px solid #dc2626' : '1px solid #cbd5e1',
                      fontSize: '13px'
                    }}
                  />
                  {rowErrors.hrs && <div style={{ color: '#dc2626', fontSize: '11px', marginTop: '4px' }}>{rowErrors.hrs}</div>}
                </td>
                <td style={{ padding: '10px' }}>
                  <input
                    type="number"
                    min="0"
                    value={chargesPerHrs}
                    onChange={(e) => setChargesPerHrs(e.target.value)}
                    placeholder="0"
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
                  />
                </td>
                <td style={{ padding: '10px', fontWeight: '600', color: '#475569' }}>
                  {currentRentalCharges}
                </td>
                <td style={{ padding: '10px', textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={tractorRequired}
                    onChange={(e) => setTractorRequired(e.target.checked)}
                    style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                  />
                </td>
                <td style={{ padding: '10px' }}>
                  {tractorRequired && (
                    <input
                      type="number"
                      min="0"
                      value={tractorRental}
                      onChange={(e) => setTractorRental(e.target.value)}
                      placeholder="0"
                      style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '6px',
                        border: rowErrors.tractor ? '1px solid #dc2626' : '1px solid #cbd5e1',
                        fontSize: '13px'
                      }}
                    />
                  )}
                  {tractorRequired && rowErrors.tractor && <div style={{ color: '#dc2626', fontSize: '11px', marginTop: '4px' }}>{rowErrors.tractor}</div>}
                </td>
                <td style={{ padding: '10px', fontWeight: '700', color: '#1b2559' }}>
                  {currentTotalRental}
                </td>
                <td style={{ padding: '10px', textAlign: 'center' }}>
                  <button
                    type="button"
                    onClick={handleAddMachine}
                    style={{
                      background: '#f59e0b',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '6px',
                      padding: '8px 16px',
                      fontWeight: '700',
                      cursor: 'pointer'
                    }}
                  >
                    ADD
                  </button>
                </td>
              </tr>

              {/* Display Added Machine Rows with Inline Edit Support */}
              {machines.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ padding: '16px', textAlign: 'center', color: '#94a3b8', fontStyle: 'italic' }}>
                    No machines added
                  </td>
                </tr>
              ) : (
                machines.map((m, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: '10px', fontWeight: '600', color: '#1e293b' }}>{m.Machine}</td>
                    
                    {/* Rented Hours Input */}
                    <td style={{ padding: '10px' }}>
                      <input
                        type="number"
                        min="1"
                        max="99"
                        value={m.MachineHrs}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === '' || (Number(val) >= 0 && val.length <= 2)) {
                            handleUpdateAddedMachine(idx, 'MachineHrs', val);
                          }
                        }}
                        style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
                      />
                    </td>

                    {/* Charges Per Hour Input */}
                    <td style={{ padding: '10px' }}>
                      <input
                        type="number"
                        min="0"
                        value={m.ChargesPerHrs}
                        onChange={(e) => handleUpdateAddedMachine(idx, 'ChargesPerHrs', e.target.value)}
                        style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
                      />
                    </td>

                    {/* Rental Charges (Auto calculated) */}
                    <td style={{ padding: '10px', fontWeight: '600', color: '#475569' }}>
                      ₹{m.MachineRental}
                    </td>

                    {/* Tractor Required Checkbox */}
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={m.TractorRequired}
                        onChange={(e) => handleUpdateAddedMachine(idx, 'TractorRequired', e.target.checked)}
                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                      />
                    </td>

                    {/* Tractor Rental Input */}
                    <td style={{ padding: '10px' }}>
                      {m.TractorRequired ? (
                        <input
                          type="number"
                          min="0"
                          value={m.TractorRental}
                          onChange={(e) => handleUpdateAddedMachine(idx, 'TractorRental', e.target.value)}
                          style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '13px' }}
                        />
                      ) : (
                        <span style={{ color: '#94a3b8' }}>₹0</span>
                      )}
                    </td>

                    {/* Total Rental (Auto calculated) */}
                    <td style={{ padding: '10px', fontWeight: '700', color: '#1b2559' }}>
                      ₹{m.TotalRental}
                    </td>

                    {/* Remove Action Button */}
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <button
                        type="button"
                        onClick={() => handleRemoveMachine(idx)}
                        style={{ background: 'transparent', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '16px' }}
                        title="Remove Machine"
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </FormContainer>
  );
};

export default AddTransactionPage;
